import { render, staticRenderFns } from "./SearchPopover.vue?vue&type=template&id=2b5b43cd&scoped=true"
import script from "./SearchPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPopover.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchPopover.vue?vue&type=style&index=0&id=2b5b43cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b43cd",
  null
  
)

export default component.exports